<template>
  <div class="code_compiler" ref="code_compiler">
    <div v-if="!image_text && !readOnly" class="code_operation_title">
      <span class="title"><span class="ber"></span> <span>代码录入</span> </span>

    </div>
    <div :style="{...textareaStyle,pointerEvents}" style="overflow: auto" ref="codeTextarea"
         :class="{task, default:!task}">
      <textarea class="codeTextarea" :ref="'coder'+ refresh "></textarea>
    </div>
    <!-- 拖拽线 -->
    <div v-if="task" class="code_compiler_line"
         @mousedown.stop="lineMove($event)"
    >
      <span class="code_line_icon">
           <svg
             style="width: 20px; height: 13px;"
             class="icon svg-icon"
             aria-hidden="true"
           >
            <use xlink:href="#icon-tuozhuai1"></use>
          </svg>
      </span>
    </div>
    <div v-if="task" class="code_operation_title">
      <span class="title"><span class="ber"></span>运行结果</span>
      <!--      <div class="goServe" @click="saveResults" v-if="questionId">-->
      <!--        <span class="el-icon-s-claim" style="font-size: 13px;"></span>-->
      <!--        保存-->
      <!--      </div>-->
      <div class="tip" v-if="codeLoading">代码编译中...<i class="el-icon-loading"></i></div>
      <div class="goServe" @click="goServe" :disabled="codeLoading">
        <svg
          style="width: 12px; height: 12px; vertical-align: -0.15em"
          class="icon svg-icon"
          aria-hidden="true"
        >
          <use xlink:href="#icon-yunhang"></use>
        </svg>
        <span>运行</span>
      </div>
    </div>
    <div v-if="task" style="overflow-y: auto">
      <div v-show="isImg" class="console_img" v-html="isImg"></div>
      <div v-show="!isImg" class="code_wrap task" :style="consoleBoxStyle">
        <textarea class="consoleBox" ref="consoleCoder"></textarea>
      </div>
    </div>

    <el-dialog
      title="请输入"
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      append-to-body
      width="450px">
      <div style="text-align: center">
        <span>{{ promptTitle }}</span>
        <el-input v-model="promptValue" style="width: 300px;"></el-input>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="handlePrompt">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import "@/utils/option";
  // 引入全局实例
  import _CodeMirror from "codemirror";
  // 尝试获取全局实例
  const CodeMirror = window.CodeMirror || _CodeMirror;

  import * as api from "@/api/courseApi";
  import qs from 'qs';

  const orig = CodeMirror.hint.javascript
  const extraJsKeywords = ('def and as assert del elif except finally from is lambda nonlocal not None pass raise with')
    .split(' ')
  CodeMirror.hint.python = (cm) => {
    const inner = orig(cm)
    const cur = cm.getCursor(),
      curLine = cm.getLine(cur.line)
    let start = cur.ch,
      end = start
    while (end < curLine.length && /[\w$]+/.test(curLine.charAt(end))) ++end
    while (start && /[\w$]+/.test(curLine.charAt(start - 1))) --start
    const curWord = start != end && curLine.slice(start, end)
    const regex = new RegExp('^' + curWord, 'i')
    const matchList = extraJsKeywords.filter((item) => item.match(regex))
    if (inner && inner.list && matchList.length) inner.list = [...inner.list, ...matchList]
    return inner
  }
  export default {
    name: "code_compiler",
    props: {
      pointerEvents: '',
      textareaStyle: {
        type: Object,
        default: () => ({
          height: '70%'
        })
      },
      value: {
        type: String,
        default: "",
      },
      output: {
        type: String,
        default: "",
      },
      questionId: {
        type: [String, Number],
        default: "",
      },
      questionAnswer: {
        type: String,
        default: "",
      },
      task: {
        type: Boolean,
        default: false,
      },
      isHas: {
        type: Boolean,
        default: false,
      },
      readOnly: {
        type: Boolean,
        default: false,
      },
      openRight: {
        type: Boolean,
        default: false,
      },
      readPage: {
        type: Boolean,
        default: false,
      },
      image_text: {
        type: Boolean,
        default: false,
      },
      refresh: {
        type: [Boolean, String, Number],
        default: true,
      },
      consoleBoxStyle: {
        type: Object,
        default: () => ({}),
      },
      language: {
        type: String,
        default: 'python'
      }
    },
    data() {
      return {
        currentValue: this.value,
        coder: null,
        consoleCoder: null,
        elt: null,
        // 默认配置
        pythonOption: {
          mode: "python",
          theme: "panda-syntax", // 主题，对应主题库 JS 需要提前引入
          tabSize: 4, // 缩进格式
          matchTags: {bothTags: true}, // 匹配标签
          matchBrackets: true, // 括号匹配
          lineNumbers: true, // 显示行号
          lineWrapping: true, //是否自动换行
          styleActiveLine: true, //line选择是是否加亮
          indentWithTabs: true,
          smartIndent: true,
          flattenSpans: false, // 将使用相同class的两个span合并成一个。
          cursorHeight: 0.85,
          autoCloseTags: true,
          autoCloseBrackets: true,
          readOnly: this.readOnly,
          inputStyle: 'contenteditable',  // textarea
          autoRefresh: true,
          indentUnit: 4, // 智能缩进单位为4个空格长度
          // 在行槽中添加行号显示器、折叠器、语法检测器
          gutters: ["CodeMirror-linenumbers", "CodeMirror-foldgutter"],
          foldGutter: true, // 启用行槽中的代码折叠
        },
        consoleOption: {
          mode: "text/x-python",
          theme: "panda-syntax", // 主题，对应主题库 JS 需要提前引入
          lineNumbers: true, // 显示行号
          lineWrapping: true, //是否自动换行
          readOnly: true,
          autoRefresh: true,
        },
        timer: null,
        isImg: '',
        codeLoading: false,
        //
        dialogVisible: false,
        promptTitle: '',
        promptValue: '',
        promptList: [],
      };
    },
    watch: {
      value: {
        handler(val) {
          this.currentValue = val;
          this.isImg = false
        },
        immediate: true,
        deep: true,
      },
      refresh: {
        handler() {
          this.refreshChange()
        },
        immediate: true,
        deep: true,
      },
    },
    mounted() {
      // 初始化
      if (this.readOnly) {
        this.$set(this.pythonOption, 'extraKeys', null);
      }
      this._initialize(this.pythonOption);
      // this.setMyInterval()
    },
    methods: {
      refreshChange() {
        if (this.coder) {
          this.coder.setValue(this.currentValue);
          this.coder.refresh();
          if (this.task) {
            this.initConsole()
          } else if (this.consoleCoder) {
            this.consoleCoder.setValue('')
          }
          // if (this.consoleCoder) this.consoleCoder.setValue('');
          // this.setMyInterval()
        }
      },
      // setMyInterval(){
      //   if (this.coder) this.coder.refresh();
      //   if (this.consoleCoder)this.consoleCoder.refresh();
      //   clearTimeout(this.timer);
      //   this.timer = setInterval(() => {
      //     this.$nextTick(() => {
      //       if (this.coder) this.coder.refresh();
      //       if (this.consoleCoder)this.consoleCoder.refresh();
      //     })
      //     if (!this.task){
      //       clearTimeout(this.timer);
      //     }
      //   }, 500)
      // },
      // 初始化
      _initialize(option) {
        let that = this;
        // 初始化编辑器实例，传入需要被实例化的文本域对象和默认配置
        that.coder = CodeMirror.fromTextArea(that.$refs['coder' + this.refresh], option);
        that.coder.setValue(that.currentValue);
        // that.coder.on("focus", (coder) => {
        //   clearTimeout(this.timer);
        // });
        if (that.readOnly) return;
        //  内容改变时触发
        that.coder.on("change", (coder) => that.coderChange(coder));
        // // 光标改变或选中改变时触发
        // that.coder.on("contextmenu", (coder, ele) => {
        //   that.$emit("contextmenu", ele);
        // });
        // 显示智能提示
        that.coder.on("inputRead", that.autoComplete);
        // 编辑器按键监听
        // that.coder.on("keypress", function() {
        //   // 显示智能提示
        //   that.coder.showHint(); // 注意，注释了CodeMirror库中show-hint.js第131行的代码（阻止了代码补全，同时提供智能提示）
        // });
        if (this.task) this.initConsole()
      },
      initConsole() {
        if (!this.consoleCoder) {
          this.consoleCoder = CodeMirror.fromTextArea(this.$refs.consoleCoder, this.consoleOption);
        }
        this.consoleCoder.setValue('');
        if (this.isHas) this.goServe();
      },
      autoComplete(cm, changeObj) {
        // There is no need to show hint when type is comment or when input characters are non-English
        if (cm.state.completionActive) return void 0;
        const token = cm.getTokenAt(cm.getCursor());
        if (token.type && token.type !== "comment") {
          if (/^[a-zA-Z]/.test(changeObj.text[0])) {
            cm.showHint();
          }
        }
      },
      // 代码块发生改变
      coderChange(coder) {
        clearTimeout(this.timer);
        this.currentValue = coder.getValue();
        this.$emit("input", this.currentValue);
      },

      // python。 的input
      handlePrompt() {
        this.promptList.push(this.promptValue);
        this.goServe('prompt');
        this.dialogVisible = false;
        this.promptValue = '';
      },

      // 代码块运行
      goServe(type) {
        if (!this.currentValue) return;
        try {
          if (this.codeLoading) return;
          this.codeLoading = true;
          this.showResult("");
          let promise = Promise.resolve();
          if (this.language === "python") {

            let param = qs.stringify({
              text: this.currentValue
            });

            if (type === 'prompt' && this.promptList.length) {
              this.promptList.forEach(item => {
                param += `&input_params=${item}`
              })
            } else {
              this.promptList = [];
            }

            promise = api.pythonRunCoder(param);

          } else if (["c", 'c++'].includes(this.language)) {
            promise = api.cppRunCoder({
              code: this.currentValue,
              lang: "cpp",
            });
          } else if (this.language === "java") {
            promise = api.javaRunCoder({
              code: this.currentValue,
            });
          } else if (this.language === "c#") {
            promise = api.csRunCoder({
              Code: this.currentValue,
            });
          }

          promise.then((res) => {
            if (this.language === "python" && res.prompt) { // input事件
              this.promptTitle = res.prompt;
              this.showResult(res.output);
              this.dialogVisible = true;
            } else if (["python", "c#"].includes(this.language)) {
              this.showResult(res.output);
            } else if (res && String(res.code) === '0') {
              if (this.language === "java") {
                this.getJavaResult(res);
              } else {
                this.showResult(res.data.output);
              }
            } else {
              this.showResult("");
            }
          }).catch(() => this.showResult("err")).finally(() => this.codeLoading = false)
        } catch (e) {
          this.codeLoading = false
        }
      },
      // java 运行后，有运行时间，单独调取结果
      // 根据状态 判断是否运行结束，没有结束，继续调用接口
      getJavaResult(r) {
        this.codeLoading = true
        if (this.getJavaResult.count == null) {
          this.getJavaResult.count = 0
        }
        api.getJavaResult(r.data).then((res) => {
          if (String(res.code) === "0") {
            if (res.data.isDone) {
              this.showResult(res.data.output);
            } else {
              if (this.getJavaResult.count < 10) {
                ++this.getJavaResult.count
                setTimeout(() => {
                  this.getJavaResult(r);
                }, 1000);
              } else {
                this.getJavaResult.count = null
              }
            }
          } else {
            this.showResult("");
          }
        }).catch(() => this.showResult("err")).finally(() => this.codeLoading = false);
      },
      showResult(output) {
        if (
          output &&
          output.includes(";base64,") &&
          output.includes("<img src=")
        ) {
          this.isImg = output;
        } else {
          this.isImg = "";
          this.consoleCoder && this.consoleCoder.setValue(output);
        }
      },
      /** 轴挪动 */
      lineMove(ev) {
        let that = this;
        let screenY = ev.screenY;
        let refHeight = this.$refs.codeTextarea.offsetHeight;
        document.onmousemove = e => {
          window.event.preventDefault(); //
          window.event.cancelBubble = true; //IE
          let maxHeight = this.$refs.code_compiler.offsetHeight;
          let height = e.screenY - screenY + refHeight
          if (maxHeight - height < 60) return
          this.$set(this.textareaStyle, 'height', height + 'px')
        };
        document.onmouseup = function () {
          document.onmousemove = null;
        };
      },
      resetValue(value) {
        this.currentValue = value
        this.coder.setValue(this.currentValue);
        this.consoleCoder.setValue('');
      }
    },
    beforeDestroy() {
      this.coder = null;
      clearTimeout(this.timer);
    },
  };
</script>

<style scoped lang="scss">

  .code_compiler {
    /*overflow: hidden;*/
    display: flex;
    flex-direction: column;
    /*height: 100%;*/
    background: #292A2B;

    .code_operation_title {
      height: 30px;
      min-height: 30px;
      color: #e5e5e5;
      display: flex;
      align-items: center;
      justify-content: space-between;
      background: #2B3C4E;

      .tip {
        user-select: none;
        font-size: 12px;
      }

      .title {
        font-size: 13px;
        font-weight: 600;
        display: flex;
        align-items: center;
      }

      .goServe {
        height: 100%;
        background: #1890FF;
        padding: 0 15px;
        color: #ffffff;
        font-size: 10px;
        cursor: pointer;
        display: flex;
        align-items: center;

        span {
          user-select: none;
        }

        svg {
          fill: #ffffff;
        }

        &:hover {
          opacity: 0.7;
        }
      }

      .ber {
        display: inline-block;
        width: 4px;
        height: 13px;
        margin-right: 15px;
        background: linear-gradient(360deg, #1890FF 0%, #00B3F7 100%, #00B3F7 100%);
        border-radius: 0px 13px 13px 0px;
      }
    }

    .console_img {
      flex: 1;
      overflow: auto;

      img {
        max-width: 100%;
      }
    }

    .code_wrap {
      flex: 1;
      overflow: auto;

      .consoleBox {
        img {
          max-width: 100%;
        }
      }
    }

    .task {
      overflow-y: auto;
    }

    .code_compiler_line {
      width: 100%;
      height: 0px;
      cursor: ns-resize;
      position: relative;
      background: #2B3C4E;

      .code_line_icon {
        padding: 0px 8px;
        position: absolute;
        background: rgba(24, 144, 255, 0.2);
        border-radius: 3px;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        z-index: 200;

        &:hover {
          background: rgba(24, 144, 255, 0.5);

          svg {
            fill: #ffffff;
          }
        }
      }

      svg {
        fill: #1890FF;
      }
    }

  }
</style>
<style>
  .CodeMirror .CodeMirror-line {
    color: #00B3F7 !important;
  }

  .CodeMirror .cm-property {
    color: #00B3F7 !important;
  }

  .CodeMirror .cm-operator {
    color: #00B3F7 !important;
  }

  /*.task .CodeMirror .CodeMirror-line {*/
  /*  color: #000000 !important;*/
  /*}*/
  .default .CodeMirror {
    min-height: 60px;
    height: auto !important;
  }

  .task .CodeMirror {
    height: 100% !important;
    width: 100%;
  }

  .cm-s-ssms .CodeMirror-gutters {
    border-right: 1px solid #e5e5e5;
  }
</style>



// WEBPACK FOOTER //
// src/views/component/code_compiler.vue